import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';

@Injectable()
export class UtilitiesService {

  constructor(
    private http: HttpClient,
    private toastyService: ToastyService
  ) { }


  /**
   *  Create toasty notification
   */
  createToasty(options) {

     // Just add default Toast with title only
     // Or create the instance of ToastOptions
     var toastOptions:ToastOptions = {
       title: options.title || '',
       msg: options.msg,
       showClose: true,
       timeout: 2500,
       theme: 'bootstrap'
     };

     switch(options.type) {
       case "default":
        this.toastyService.info(toastOptions);
       break;
       case "success":
        this.toastyService.success(toastOptions);
       break;
       case "wait":
        this.toastyService.wait(toastOptions);
       break;
       case "error":
        this.toastyService.error(toastOptions);
       break;
       case "warning":
        this.toastyService.warning(toastOptions);
       break;
     }
   }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/utilities.service.ts